/**
 * Shared Cart Cookie Sync
 *
 * Keeps the `sharedCart` cookie (on .wypeuk.com) in sync with Shopify's `cart`
 * cookie after every cart mutation. This allows try.wypeuk.com (headless) to
 * read the current cart token via the shared domain-level cookie.
 *
 * Zero dependencies — uses raw document.cookie only.
 */
(function () {
  var CART_ENDPOINTS = ['/cart/add.js', '/cart/update.js', '/cart/change.js', '/cart/clear.js'];
  var COOKIE_DOMAIN = '.wypeuk.com';
  var COOKIE_EXPIRY_DAYS = 7;

  function getCartCookie() {
    var cookies = document.cookie.split('; ');
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      if (parts[0] === 'cart') {
        return decodeURIComponent(parts.slice(1).join('='));
      }
    }
    return null;
  }

  function syncSharedCartCookie() {
    var cartValue = getCartCookie();
    if (!cartValue) {
      // Expire the shared cookie so try.wypeuk.com doesn't read a stale cart
      document.cookie =
        'sharedCart=' +
        '; domain=' + COOKIE_DOMAIN +
        '; path=/' +
        '; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
        '; SameSite=None; Secure';
      return;
    }

    var expires = new Date();
    expires.setTime(expires.getTime() + COOKIE_EXPIRY_DAYS * 24 * 60 * 60 * 1000);

    document.cookie =
      'sharedCart=' + encodeURIComponent(cartValue) +
      '; domain=' + COOKIE_DOMAIN +
      '; path=/' +
      '; expires=' + expires.toUTCString() +
      '; SameSite=None; Secure';
  }

  function isCartMutation(url) {
    if (!url) return false;
    for (var i = 0; i < CART_ENDPOINTS.length; i++) {
      if (url.indexOf(CART_ENDPOINTS[i]) !== -1) return true;
    }
    return false;
  }

  function toUrlString(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input === 'object') return input.url || String(input);
    return '';
  }

  // --- Monkey-patch fetch ---
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function () {
      var url = toUrlString(arguments[0]);

      var result = originalFetch.apply(this, arguments);

      if (isCartMutation(url)) {
        result.then(function (response) {
          if (response.ok) {
            syncSharedCartCookie();
          }
        }).catch(function () {});
      }

      return result;
    };
  }

  // --- Monkey-patch XMLHttpRequest ---
  var originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function () {
    var method = arguments[0];
    var url = arguments[1];

    if (typeof url === 'string' && isCartMutation(url)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          syncSharedCartCookie();
        }
      });
    }

    return originalXHROpen.apply(this, arguments);
  };

  // --- Safety net: sync before leaving the page ---
  window.addEventListener('beforeunload', syncSharedCartCookie);

  // --- Initial sync on script load ---
  syncSharedCartCookie();
})();
